import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './PrintNode.frontend.types'

@Injectable({ providedIn: 'root' })
export class PrintNode_set_device_associations_by_type_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { entity_type: $frontendTypes.PrintNode.e_entity_type, entity_id: string, device_ids: string[], device_type: $frontendTypes.PrintNode.e_device_type }): Promise<{ reasons?: string[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.entity_type)) {
      $missingRequiredInParams.push('\'entity_type\'');
    }
    if (isNil($inParams.entity_id)) {
      $missingRequiredInParams.push('\'entity_id\'');
    }
    if (isNil($inParams.device_ids)) {
      $missingRequiredInParams.push('\'device_ids\'');
    }
    if (isNil($inParams.device_type)) {
      $missingRequiredInParams.push('\'device_type\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

